import c from 'classnames';
import { graphqlApiSite } from 'core/api/graphql';
import toggleEnhancer, { IToggleEnhacerProps } from 'core/enhancers/toggleEnhancer';
import { showSnackbar } from 'core/components/snackbar';
import injectSheet, { createStyles } from 'core/style/injectSheet';
import { ITheme, WithStyles } from 'core/style/interfaces';
import { isMobile } from 'core/utils';
import React from 'react';
import compose from 'recompose/compose';
import { Product } from 'site/graphql';
import MenuIcon from '../../../svg/vertical-three-dots.svg';

const styles = (theme: ITheme) =>
    createStyles({
        container: {
            background: 'white',
            border: `1px solid ${theme.colors.lightGray}`,
            width: 180,
            zIndex: 2,
            position: 'absolute',
            right: -180,
            color: theme.colors.textMedium,
        },
        containerMobile: {
            right: 35,
        },
        menuIcon: {
            width: 20,
            height: 20,
            fill: '#A7A7A7',
            position: 'absolute',
            right: 8,
            cursor: 'pointer',

            '&:hover': {
                fill: '#777777',
            },
        },
        divider: {
            height: 1,
            backgroundColor: theme.colors.lightGray,
        },
        menuItem: {
            padding: '5px 10px',
            cursor: 'pointer',

            '&:hover': {
                backgroundColor: theme.colors.lightGray,
            },
        },
    });

class ProductCardMenu extends React.Component<IInnerProps> {
    componentDidMount() {
        document.addEventListener('click', this.closeIfClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.closeIfClickOutside);
    }

    closeIfClickOutside = e => {
        const {
            toggle,
            product: { id },
            offToggle,
            onToggle,
        } = this.props;

        if (e.target.closest(`#js-product-menu-icon-${id}`)) {
            onToggle();
        }

        if (toggle && !e.target.closest(`#js-product-menu-${id}`)) {
            offToggle();
        }
    };

    addProductToArchive = () => {
        if (confirm('Вы уверены, что хотите добавить курс в архив?')) {
            const {
                product: { id },
                fetchProducts,
            } = this.props;
            const mutation = `mutation {
                archiveProduct(productId: ${id})
            }`;

            graphqlApiSite<{ archiveProduct: boolean }>(mutation, null)
                .then(({ data }) => {
                    if (data.archiveProduct) {
                        showSnackbar({ snackbarMessage: 'Курс добавлен в архив' });
                        fetchProducts();
                    }
                })
                .catch(() => showSnackbar({ snackbarErrors: [{ message: 'Ошибка добавления курса в архив' }] }));
        }
    };

    deleteProductOrders = () => {
        if (confirm('Вы уверены, что хотите удалить курс? Все записи и материалы данного курса не будут доступны.')) {
            const {
                product: { id },
                fetchProducts,
            } = this.props;
            const mutation = `mutation {
                deleteProductOrders(productId: ${id})
            }`;

            graphqlApiSite<{ deleteProductOrders: boolean }>(mutation, null)
                .then(({ data }) => {
                    if (data.deleteProductOrders) {
                        showSnackbar({ snackbarMessage: 'Курс удален' });
                        fetchProducts();
                    }
                })
                .catch(() => showSnackbar({ snackbarErrors: [{ message: 'Ошибка удаления курса' }] }));
        }
    };

    render() {
        const {
            classes,
            product: { id, isArchive, isFree },
            toggle,
            menuIconRight,
        } = this.props;

        if (isArchive && !isFree) {
            return null;
        }

        return (
            <React.Fragment>
                <MenuIcon
                    id={`js-product-menu-icon-${id}`}
                    className={classes.menuIcon}
                    style={{ right: menuIconRight }}
                />
                {toggle && (
                    <div
                        className={c(classes.container, { [classes.containerMobile]: isMobile() })}
                        id={`js-product-menu-${id}`}
                    >
                        {!isArchive && (
                            <div className={classes.menuItem} onClick={this.addProductToArchive}>
                                Добавить в архив
                            </div>
                        )}
                        {!isArchive && isFree && <div className={classes.divider} />}
                        {isFree && (
                            <div className={classes.menuItem} onClick={this.deleteProductOrders}>
                                Удалить
                            </div>
                        )}
                    </div>
                )}
            </React.Fragment>
        );
    }
}

type IOutterProps = {
    product: Product;
    fetchProducts: () => void;
    menuIconRight?: number;
};
type IInnerProps = IOutterProps & IToggleEnhacerProps & WithStyles<typeof styles>;

export default compose<IInnerProps, IOutterProps>(toggleEnhancer, injectSheet(styles, 'ProductCard'))(ProductCardMenu);
